export class PosterDefinition {
  constructor(
    public aspectRatio?: string,
    public catalogPoster?: boolean,
    public code?: number,
    public compressRatio?: number,
    public description?: string,
    public fileSize?: number,
    public height?: number,
    public id?: number,
    public mainboardPoster?: boolean,
    public mandatoryPoster?: boolean,
    public name?: string,
    public type?: string,
    public width?: number,
    public platforms?: string[],
    public posterType?: any,
  ) {}
}

// Inline Model 1 {
//   aspectRatio (string, optional),
//   catalogPoster (boolean, optional),
//   code (integer, optional),
//   compressRatio (number, optional),
//   description (string, optional),
//   fileSize (integer, optional),
//   height (integer, optional),
//   id (integer, optional),
//   mainboardPoster (boolean, optional),
//   mandatoryPoster (boolean, optional),
//   name (string, optional),
//   platforms (Array[string], optional) = ['Web', 'SmartTV', 'Mobile', 'IPTV', 'STB'],
//   posterType (any, optional),
//   type (string, optional) = ['Content', 'Cast', 'Epg', 'Category'],
//   width (integer, optional)
//   }
